import { type IWithdrawUsdRequestContext, WithdrawUsdRequestContext } from 'BreetComponents';
import { useContext } from 'react';

export const useWithdrawUsdRequestContext = (): IWithdrawUsdRequestContext => {
	const withdrawUsdRequestContext = useContext(WithdrawUsdRequestContext);

	if (!withdrawUsdRequestContext) {
		throw new Error('useWithdrawUsdRequestContext must be used within a WithdrawUsdRequestProvider');
	}

	return withdrawUsdRequestContext;
};
